import React, { useState } from 'react'
import Permissions from 'components/permissions'
import { AccessResourceKinds, PROJECT } from 'app-constants'
import { useDataContext } from 'components/document/contexts/data'
import Modal, { ModalProps } from 'components/modal'
import useProject from 'hooks/useProject'
import { useApplicationStore } from 'hooks/application'
import api from 'helpers/api'
import Button from 'components/button'
import Select from 'components/select'

const PermissionsModal: React.FC<ModalProps> = ({ id, open, setOpen, onClose }) => {
  const { project } = useProject()
  const { setSnackbarMessage, displayErrorMessage } = useApplicationStore()
  const [screen, setScreen] = useState<number>(0)
  const [loading, setLoading] = useState<boolean>(false)
  const [viewerProjectPermissionForSelects, setViewerProjectPermissionForSelects] = useState<boolean>(false)
  const { process } = useDataContext()

  const handleBulkSyncPermissions = () => {
    if (project && process) {
      setLoading(true)
      api

        .updateViewsProcessPermissions(process.publicId, viewerProjectPermissionForSelects)
        .then(() => {
          setSnackbarMessage({ message: 'View permissions have been synced successfully!', status: 'success' })
          setOpen(false)
        })
        .catch((error) => displayErrorMessage(error))
        .finally(() => setLoading(false))
    }
  }

  const handleCancelSyncPermissions = () => {
    setViewerProjectPermissionForSelects(false)
    setLoading(false)
    setScreen(0)
  }

  if (process) {
    return (
      <Modal
        id={id}
        open={open}
        setOpen={setOpen}
        title={`${screen == 1 ? 'Sync ' : ''}Permissions`}
        onClose={() => {
          setLoading(false)
          if (onClose) onClose()
        }}
      >
        {screen == 0 && (
          <div className="m-2.5 list-none">
            <div className="flex items-center border-b-2 border-divider py-2.5 mb-4 font-bold">Sync Permissions</div>
            <div>
              A <b>one-off</b> synchronisation of permissions for <b>all table views</b> contained in the document. If a
              user has contributor access to the document, they will be added as a contributor to all views contained in
              this document. No permissions will be removed from the table views.
            </div>
            <div className="flex items-center mb-10 mt-5">
              <Button
                internalType="accept"
                className="text-base"
                onClick={() => {
                  setScreen(1)
                }}
              >
                <span>Sync Permissions</span>
              </Button>
            </div>

            <div className="border-b-2 border-divider py-2.5 mb-4 font-bold">Document Permissions</div>
            <Permissions resource={AccessResourceKinds.PROCESS} resourceId={process.publicId} />
          </div>
        )}
        {screen == 1 && (
          <div className="m-2.5 list-none">
            <div className="flex items-center justify-center mt-5 mb-[30px]">
              <div>
                Automatically assign {PROJECT.toLowerCase()} members as viewers on all source views for select and
                multiselect columns in this document (if any)?
              </div>
              <div className="ml-auto w-[150px]">
                <Select
                  options={[
                    { value: 'Yes', label: 'Yes' },
                    { value: 'No', label: 'No' }
                  ]}
                  optionsSelected={[viewerProjectPermissionForSelects ? 'Yes' : 'No']}
                  onOptionClick={(option) => setViewerProjectPermissionForSelects(option === 'Yes')}
                  searchable={false}
                />
              </div>
            </div>
            <div className="flex items-center justify-end mt-5">
              <Button internalType="danger" disabled={loading} onClick={() => handleCancelSyncPermissions()}>
                Cancel
              </Button>

              <Button
                className="ml-2.5"
                internalType="accept"
                onClick={() => handleBulkSyncPermissions()}
                isLoading={loading}
              >
                Confirm
              </Button>
            </div>
          </div>
        )}
      </Modal>
    )
  } else {
    return <div />
  }
}

export default PermissionsModal
